import { useQuery } from 'react-query';
import usePlanStore, { ComparedPlan } from '../../../../../../store/planStore';
import { getMultiplePlans } from '../../../../../../api/services/mediaPlanning/getMultiplePlans';
import { ApiResponse } from '../../../../../../api/types';

const useFetchMultiplePlans = (ids: string[]) => {
  const { setComparedPlans } = usePlanStore();

  const query = useQuery<ApiResponse<ComparedPlan[]>, unknown>(
    ['multiplePlans', ids.join(',')],
    () => getMultiplePlans(ids),
    {
      enabled: ids.length > 0,
      keepPreviousData: true,
      onSuccess: (response) => {
        const plans = response.data ?? [];
        const sorted = [...plans].sort(
          (a, b) => ids.indexOf(a.id) - ids.indexOf(b.id)
        );
        setComparedPlans(sorted);
      },
    }
  );

  return {
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    error: query.error,
    refetch: query.refetch,
  };
};

export default useFetchMultiplePlans;
